import React from 'react';

import { Box } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import PickupTimeSelector from 'components/pickup-time-selector';
import { isDelivery } from 'utils/service-mode';

import SectionHeading from '../section-heading';

import DeliveryDetails from './delivery-details';
import { PickupDetails } from './pickup-details';
import { PickupTimeHeadingContainer } from './styled';
import { ICartDetailsProps } from './types';

export const DetailsV2: React.FC<React.PropsWithChildren<ICartDetailsProps>> = ({
  readOnly = false,
  onTimeSelectorChange,
  onDeliveryStatusChange,
  timeSelectorValue,
  serverOrder,
  serviceMode,
  setAreDeliveryDetailsValid,
  isOrderTimedFire,
  isPickupTimeAvailable,
  phoneNumberInputRef,
  deliveryDetailsErrors,
}) => {
  const { formatMessage } = useIntl();

  const isDeliveryOrder = isDelivery(serviceMode);

  const sectionHeading = isDeliveryOrder ? 'deliveryDetails' : 'restaurantDetails';

  return (
    <>
      {isDeliveryOrder ? (
        <DeliveryDetails
          serverOrder={serverOrder}
          setAreDeliveryDetailsValid={setAreDeliveryDetailsValid}
          sectionHeading={sectionHeading}
          phoneNumberInputRef={phoneNumberInputRef}
          deliveryDetailsErrors={deliveryDetailsErrors}
        />
      ) : (
        <PickupDetails serviceMode={serviceMode} readOnly={readOnly} />
      )}
      {isOrderTimedFire && (
        <Box>
          <PickupTimeHeadingContainer>
            <SectionHeading>
              {isDeliveryOrder
                ? formatMessage({ id: 'deliveryTime' })
                : formatMessage({ id: 'pickUpTime' })}
            </SectionHeading>
          </PickupTimeHeadingContainer>
          <PickupTimeSelector
            onChange={value => onTimeSelectorChange && onTimeSelectorChange(value)}
            onDeliveryStatusChange={onDeliveryStatusChange}
            isPickupTimeAvailable={isPickupTimeAvailable}
            showAsTime
            value={timeSelectorValue || 0}
          />
        </Box>
      )}
    </>
  );
};
